import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'

const OffDayTypeRepository = RepositoryFactory.get('offDayType')

class OffDayTypeService {
  static async getTypes (params) {
    try {
      return await OffDayTypeRepository.getTypes(params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default OffDayTypeService
